'use client'

import { Button } from '@/components/ui/button'
import { ArrowRight } from 'lucide-react'
import Image from 'next/image'

export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id)
    element?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <section className="w-full min-h-screen flex items-center justify-center bg-white pt-20 overflow-hidden relative">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-secondary/10 rounded-full blur-3xl -z-10"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-primary/10 rounded-full blur-3xl -z-10"></div>

      <div className="max-w-6xl mx-auto px-6 py-20 flex flex-col gap-12">
        <div className="flex flex-col gap-6">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 w-fit px-4 py-2 rounded-full bg-secondary/15 border border-secondary/30">
            <span className="w-2.5 h-2.5 rounded-full bg-secondary animate-pulse"></span>
            <span className="text-sm font-semibold text-secondary">Android Exclusive Launch</span>
          </div>

          {/* Main heading */}
          <div className="space-y-6 flex flex-col items-start">
            <div className="flex items-center gap-4">
              <Image 
                src="/applogo-alarvia.png" 
                alt="Alarvia Logo" 
                width={80}
                height={80}
                className="w-16 h-16 md:w-20 md:h-20"
              />
              <h1 className="text-5xl md:text-7xl font-bold text-foreground leading-tight">
                Care That <span className="text-primary">Remembers</span>
              </h1>
            </div>
            <p className="text-xl md:text-2xl text-muted-foreground max-w-3xl leading-relaxed">
              Smart medicine reminders with full-screen alarms, voice alerts, and caregiver support. Finally, reliable medication management for everyone.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 pt-4">
            <Button
              size="lg"
              onClick={() => scrollToSection('preregister')}
              className="bg-primary hover:bg-accent text-white font-bold text-lg h-14 px-8 group"
            >
              Pre-Register on Android
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => scrollToSection('features')}
              className="border-2 border-primary text-primary hover:bg-primary/5 font-bold text-lg h-14 px-8"
            >
              Learn More
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 md:gap-16 pt-8 border-t border-muted">
            <div className="space-y-2">
              <p className="text-3xl font-bold text-primary">99%</p>
              <p className="text-sm text-muted-foreground">Alarm Reliability</p>
            </div>
            <div className="space-y-2">
              <p className="text-3xl font-bold text-primary">Real-time</p>
              <p className="text-sm text-muted-foreground">Caregiver Updates</p>
            </div>
            <div className="space-y-2">
              <p className="text-3xl font-bold text-secondary">Instant</p>
              <p className="text-sm text-muted-foreground">Voice Alerts</p>
            </div>
          </div>
        </div>


      </div>
    </section>
  )
}
